module.exports = __webpack_public_path__ + "img/distinctions/image-04@2x.jpg";